// extracted by mini-css-extract-plugin
export default {"courseInfoContainer":"CourseTop_courseInfoContainer__hEzUc","courseTopContainer":"CourseTop_courseTopContainer__Yrx-N"};